<!-- ======= Header ======= -->
<header id="header" class="fixed-top">
  <div class="container d-flex align-items-center">
    <a class="logo me-auto" (click)="closeMenu()" routerLink="/"><img id="logo1" [src]="logoSrc"></a>

    <nav id="navbar" class="navbar order-last order-lg-0">
      <ul>
        <li><a routerLink="/" (click)="closeMenu()">Home</a></li>
        <li><a routerLink="/sthandarshan" (click)="closeMenu()"><span class="marathi-font-lg">स्थान दर्शन</span></a></li>
        <li class="dropdown"><a><span class="marathi-font-lg">स्मृतीस्थळ</span><i class="bi bi-chevron-down"></i></a>
          <ul>
            <li><a routerLink="/smruti/smruti" (click)="closeMenu()"><span class="marathi-font-lg">स्मृतीस्थळ</span></a>
            </li>
            <li><a routerLink="/smruti/vruddhachar" (click)="closeMenu()"><span
                  class="marathi-font-lg">वृद्धाचर</span></a></li>
            <li><a routerLink="/smruti/adnyat" (click)="closeMenu()"><span class="marathi-font-lg">अज्ञात
                  स्मृती</span></a></li>
          </ul>
        </li>
        <li class="dropdown"><a><span class="marathi-font-lg">साहित्य</span> <i class="bi bi-chevron-down"></i></a>
          <ul>
            <li><a routerLink="/sahitya/books" (click)="closeMenu()"><span class="marathi-font-lg">पुस्तक</span></a>
            </li>
            <li><a routerLink="/sahitya/pothi" (click)="closeMenu()"><span class="marathi-font-lg">पोथी</span></a></li>
          </ul>
        </li>
        <li class="dropdown"><a><span class="marathi-font-lg">चरित्र</span> <i class="bi bi-chevron-down"></i></a>
          <ul>
            <li class="dropdown"><a><span class="marathi-font-lg">लीळाचरित्र</span><i
                  class="bi bi-chevron-right"></i></a>
              <ul>
                <li><a routerLink="/charitra/lila/purvardha" (click)="closeMenu()"><span
                      class="marathi-font-lg">पूर्वार्ध</span></a></li>
                <li><a routerLink="/charitra/lila/uttarardha" (click)="closeMenu()"><span
                      class="marathi-font-lg">उत्तरार्ध</span></a></li>
                <li><a routerLink="/charitra/lila/adnyat" (click)="closeMenu()"><span
                      class="marathi-font-lg">अज्ञत</span></a></li>
              </ul>
            </li>
            <li><a routerLink="/charitra/shrikrushna" (click)="closeMenu()"><span class="marathi-font-lg">श्रीकृष्ण
                  चरित्र </span></a></li>
            <li><a routerLink="/charitra/shridatta" (click)="closeMenu()"><span class="marathi-font-lg">श्री दत्तात्रेय
                  चरित्र </span></a></li>
            <li class="dropdown"><a><span class="marathi-font-lg">श्री गोविंद प्रभू चरित्र</span><i
                  class="bi bi-chevron-right"></i></a>
              <ul>
                <li><a routerLink="/charitra/shriprabhu/rpurvardha" (click)="closeMenu()"><span
                      class="marathi-font-lg">पूर्वार्ध</span></a></li>
                <li><a routerLink="/charitra/shriprabhu/ruttarardha" (click)="closeMenu()"><span
                      class="marathi-font-lg">उत्तरार्ध</span></a></li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="dropdown"><a><span class="marathi-font-lg">पाठ</span> <i class="bi bi-chevron-down"></i></a>
          <ul>
            <li><a routerLink="/path/sutrapath/nauprakaran" (click)="closeMenu()"><span
                  class="marathi-font-lg">सूत्रपाठ</span></a>

            <li><a routerLink="/path/sutrapath/drustant" (click)="closeMenu()"><span
                  class="marathi-font-lg">दृत्तांत</span></a>
            </li>
            <li><a routerLink="/path/arti/arti" (click)="closeMenu()"><span class="marathi-font-lg">आरती/भजन</span></a>
            </li>
            <li><a routerLink="/smruti/stotra" (click)="closeMenu()"><span class="marathi-font-lg">स्तोत्र</span></a>
            </li>
          </ul>
        </li>
        <li class="dropdown"><a>Gallery<i class="bi bi-chevron-down"></i></a>
          <ul>
            <li><a routerLink="/gallary/songs" (click)="closeMenu()">Songs</a></li>
            <li><a routerLink="/gallary/images" (click)="closeMenu()">Images</a></li>
            <li><a routerLink="/gallary/videos" (click)="closeMenu()">Videos</a></li>
          </ul>
        </li>
        <li><a routerLink="/contact" (click)="closeMenu()">Contact</a></li>
      </ul>
      <i class="bi bi-list mobile-nav-toggle"></i>
    </nav><!-- .navbar -->

    <a routerLink="/android/apps" (click)="closeMenu()" class="get-started-btn"><i class="bi bi-android2"></i>
      Andriod Apps</a>

  </div>
</header><!-- End Header -->

<router-outlet></router-outlet>

<!-- ======= Footer ======= -->
<footer id="footer">

  <div class="footer-top">
    <div class="container">
      <div class="row">

        <div class="col-lg-3 col-md-6 footer-contact">
          <h3> <span class="marathi-font">परमार्ग सेवक</span></h3>
          <img src="../assets/images/Aniruddha Bhave.sarvadhnya.com.jpg" class="padding-2 border mb-1"><br><br>
          <p>
            <span class="marathi-font-lg">श्री अनिरुद्ध भावे</span><br>
            New Manish Nagar,<br>
            Nagpur, Maharashtra<br>
            India - 440026<br>
            <strong>Phone:</strong> (+91) 9850149316<br>
            <strong>Email:</strong> aniruddha.bhave1962@gmail.com<br>
          </p>
        </div>

        <div class="col-lg-2 col-md-6 footer-links">
          <h4>Useful Links</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a href="/">Home</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="/about">Contact</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="/sthan" >
                <span class="marathi-font-lg">स्थान दर्शन</span></a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="/gallary/songs" >Songs</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="/gallary/images" >Images</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/policy/tnc">Terms of service</a></li>
            <li><i class="bx bx-chevron-right"></i> <a routerLink="/policy/disclaimer">Disclaimer</a></li>
          </ul>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4>Our Services</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/lila" (click)="closeMenu()"><span
                  class="marathi-font-lg">लीलाचरित्र</span></a></li>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/smruti" (click)="closeMenu()"><span
                  class="marathi-font-lg">स्मृतीस्थळ</span></a></li>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/arti" (click)="closeMenu()"><span
                  class="marathi-font-lg">आरती/भजन</span></a></li>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/books" (click)="closeMenu()"><span
                  class="marathi-font-lg">पुस्तक</span></a></li>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/pothi" (click)="closeMenu()"><span
                  class="marathi-font-lg">पोथी</span></a></li>
            <li><i class="bx bx-chevron-right"></i><a href="/sahitya/stotra" (click)="closeMenu()"><span
                  class="marathi-font-lg">स्तोत्र</span></a></li>
          </ul>
        </div>

        <div class="col-lg-4 col-md-6 footer-newsletter row">
          <div class="col-lg-12 col-md-12 footer-newsletter">
            <h4>Go social</h4>
            <iframe
              src="//www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com/sarvadhnya&amp;width&amp;layout=standard&amp;action=like&amp;show_faces=true&amp;colorscheme=dark&amp;share=true&amp;height=80&amp;appId=262053443812425"
              scrolling="no" frameborder="0" style="border:none; overflow:auto; height:100px;" data-colorscheme="light"
              allowtransparency="true"></iframe>
          </div>
          <div class="col-lg-12 col-md-12 footer-newsletter">
            <h4>Join Our Newsletter</h4>
            <p>Subscribe with email to keep yourself updated with latest news on this site</p>
            <form action="" method="post">
              <input type="email" name="email" required><input type="submit" value="Subscribe">
            </form>
          </div>

        </div>




      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">

    <div class="me-md-auto text-center text-md-start">
      <div class="copyright">
        &copy;<a routerLink="/policy/copyrights">Copyright </a> <strong><span>sarvadhnya.com</span></strong>. All Rights
        Reserved - {{year}}
      </div>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you purchased the pro version. -->
        <!-- Licensing information: https://bootstrapmade.com/license/ -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/mentor-free-education-bootstrap-theme/ -->
        Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a> | Developed by <a
          routerLink="/contact">Kartik Bhave</a>
      </div>
    </div>
    <div class="social-links text-center text-md-right pt-3 pt-md-0">
      <a href="https://twitter.com/KartikBhave" class="twitter"><i class="bx bxl-twitter"></i></a>
      <a href="https://www.facebook.com/people/Mahanubhav-Panth/100063745628869/" class="facebook"><i
          class="bx bxl-facebook"></i></a>
      <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
      <a href="https://www.youtube.com/@adityabhave3519" class="google-plus"><i class="bi bi-youtube"></i>
      </a>
      <a href="https://www.linkedin.com/in/kartik-bhave-776a1157/" class="linkedin"><i class="bx bxl-linkedin"></i></a>
    </div>
  </div>
</footer><!-- End Footer -->

<script>

</script>